import { ReactElement } from 'react';
import { ChecklistSectionCommentBlock } from 'components/common/checklistTree';
import { SectionTreeNode } from 'shared/domain/checklistTree';
import {
  useInspectionSectionReadOnly,
  useInspectionSectionUploaders,
} from '../useInspectionSectionUploaders';

interface SectionContentFormProps {
  node: SectionTreeNode;
  comment: string;
  formKey: string;
  fieldName: string;
}

export function SectionContentForm({
  node,
  comment,
  formKey,
  fieldName,
}: SectionContentFormProps): ReactElement {
  const readOnly = useInspectionSectionReadOnly();

  return (
    <MountedInspectionSectionUploaders
      node={node}
      comment={comment}
      formKey={formKey}
      fieldName={fieldName}
      readOnly={readOnly}
    />
  );
}

function MountedInspectionSectionUploaders({
  node,
  comment,
  formKey,
  fieldName,
  readOnly,
}: SectionContentFormProps & { readOnly: boolean }): ReactElement {
  const {
    templateGraphicUploader,
    graphicUploader,
    uploaderKey,
    shouldShowTemplateUploaderForRoute,
    shouldShowProtocolUploaderForRoute,
  } = useInspectionSectionUploaders({
    node,
    readOnly,
    enableAtomicChanges: true,
  });

  return (
    <ChecklistSectionCommentBlock
      description={node.data.description}
      comment={comment}
      editable={!readOnly}
      formKey={formKey}
      fieldName={fieldName}
      templateGraphicUploader={templateGraphicUploader}
      graphicUploader={graphicUploader}
      uploaderKey={uploaderKey}
      forceShowTemplateGraphicUploader={shouldShowTemplateUploaderForRoute}
      forceShowProtocolGraphicUploader={shouldShowProtocolUploaderForRoute}
    />
  );
}
